var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 24C28.5 23.1875 29.1562 22.5 30 22.5C30.8125 22.5 31.5 23.1875 31.5 24C31.5 24.8438 30.8125 25.5 30 25.5C29.1562 25.5 28.5 24.8438 28.5 24ZM19.5 24C19.5 24.8438 18.8125 25.5 18 25.5C17.1562 25.5 16.5 24.8438 16.5 24C16.5 23.1875 17.1562 22.5 18 22.5C18.8125 22.5 19.5 23.1875 19.5 24ZM25.5 24C25.5 24.8438 24.8125 25.5 24 25.5C23.1562 25.5 22.5 24.8438 22.5 24C22.5 23.1875 23.1562 22.5 24 22.5C24.8125 22.5 25.5 23.1875 25.5 24Z",
    fill: "#181818"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    stroke: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreButton);
export default __webpack_public_path__ + "static/media/more-button.1744f25850ee00cabe63691e2fd4d5b0.svg";
export { ForwardRef as ReactComponent };